<template>
  <div>
    <el-row class="form-setting" :gutter="8">
      <el-col :span="1">
      </el-col>

      <el-col class="left-content" :span="6">
        <h3>选项</h3>
        <div class="type-box clearfix">
          <h4 style="color: #606266;">常用字段</h4>
          <ul class="two-column-list">
            <li v-for="item in commonTypes" :key="item.key" @click="onClickType(item.key)">
              <i :class="[item.icon, 'icon-color']"></i>
              {{ item.value }}
            </li>
          </ul>
          <br>
        </div>

        <el-divider style="color: gray;"></el-divider>

        <div class="type-box clearfix">
          <h4 style="color: #606266;">可选类型</h4>
          <ul class="two-column-list">
            <li v-for="item in optionalType" :key="item.key" @click="onClickType(item.key)">
              <i :class="[item.icon, 'icon-color']"></i>
              {{ item.value }}
            </li>
          </ul>
        </div>
      </el-col>
      <el-col class="right-content" :span="17">

        <h3>预约表单</h3>

        <el-form size="mini" label-width="100px" label-position="left">

          <FormItemView v-for="(item, index) in formDefineList" :formItemInfo="item" :itemIndex="index"
                        :listSize="formDefineList.length" :formData="formDefineList" @message="handleMessage"
                        :key="item.id">
          </FormItemView>

          <el-form-item>
            <el-button type="primary" @click="submitForm" :disabled="!hasCommitPermission">提交</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import FormItemView from './FormItemView.vue';
import {addFormData, getFormData} from '@/api/apply-api'

export default {
  components: {FormItemView},
  props: ['visitType'],

  data() {
    return {
      apiType: "", // BOOK_APPLY，INVITE_APPLY

      formDataOrigin: {},

      formDefineList: [],

      maxId: 1234,

      commonTypes: [
        {icon: 'el-icon-notebook-1', value: '来访事由', key: '11'},
        {icon: 'el-icon-s-home', value: '来访单位', key: '12'},
        {icon: 'el-icon-location-outline', value: '拜访地址', key: '13'},
        {icon: 'el-icon-truck', value: '车牌号码', key: '14'},
        {icon: 'el-icon-notebook-2', value: '备注', key: '15'},
        {icon: 'el-icon-s-custom', value: '同行人', key: '16'},
      ],

      optionalType: [
        {icon: 'el-icon-document', value: '文本', key: '21'},
        {icon: 'el-icon-document-copy', value: '下拉框', key: '22'},
        {icon: 'el-icon-date', value: '日期', key: '23'},
        // {icon: 'el-icon-crop', value: '图片', key: '24'},
        {icon: 'el-icon-edit', value: '数字', key: '25'},
      ],

    }
  },

  methods: {
    createDefaultForm() {
      let defaultForm = {
        business: "VISITOR",
        type: this.apiType,
        formItems: [
          {
            id: 2,
            name: "startTime",
            title: "开始时间",
            title_en: "Begin Time",
            type: "beginTime",
            value: "",
            valueList: "",
            valueDefault: "",
            required: 1
          },
          {
            id: 3,
            name: "endTime",
            title: "结束时间",
            title_en: "End Time",
            type: "endTime",
            value: "",
            valueList: "",
            valueDefault: "",
            required: 1
          }
        ]
      }
      this.formDataOrigin = defaultForm
      this.formDefineList = JSON.parse(JSON.stringify(defaultForm.formItems))
    },

    crateFormData(item) {
      console.log("onClickType", item);
      this.maxId += 1

      let id = this.maxId
      let name = `${id}`
      let title = ""
      let value = ""
      let valueList = ""
      let valueDefault = ""
      let required = 0
      let type

      switch (item) {
        case '11':
          name = "reason"
          type = "reason"
          valueList = [
            {value: "商务洽谈", signOutTime: ""},
            {value: "面试", signOutTime: ""},
            {value: "送快递", signOutTime: ""},
            {value: "送货", signOutTime: ""},
            {value: "维修", signOutTime: ""},
            {value: "会议", signOutTime: ""},
          ]
          title = "来访事由"
          break;
        case '12':
          name = "unit"
          type = "company"
          title = "来访单位"
          break;
        case '13':
          name = "visitAddress"
          type = "address"
          valueList = [
            {value: "选项一"},
            {value: "选项二"},
          ]
          title = "拜访地址"
          break;
        case '14':
          name = "carNumber"
          type = "car"
          title = "车牌号码"
          break;
        case '15':
          name = "note"
          type = "comments"
          title = "备注"
          break;
        case '16':
          name = "peer"
          type = "accompany"
          title = "同行人"
          break;
        case '21':
          type = "input"
          title = "文本"
          break;
        case '22':
          type = "picker"
          valueList = [
            {value: "选项一"},
            {value: "选项二"},
          ]
          title = "下拉框"
          break;
        case '23':
          type = "timer"
          title = "日期"
          break;
        case '24':
          type = "file"
          title = "图片"
          break;
        case '25':
          type = "number"
          title = "数字"
          break;
        default:
          break;
      }
      let valueListStr = ""
      if (valueList !== "") {
        valueListStr = JSON.stringify(valueList)
      }
      return {id, name, title, value, valueList: valueListStr, valueDefault, required, type}
    },

    addDefaultEngine(data) {
      switch (data.name) {
        case 'reason': {
          data.title_en = "Visit Reason"
          let valueList = JSON.parse(data.valueList)
          valueList.forEach((item) => {
            switch (item.value) {
              case "商务洽谈":
                item.value_en = "Business"
                break;
              case "面试":
                item.value_en = "Job Interview"
                break;
              case "送快递":
                item.value_en = "Delivery Parcel"
                break;
              case "送货":
                item.value_en = "Delivery Goods"
                break;
              case "维修":
                item.value_en = "Repair"
                break;
              case "会议":
                item.value_en = "Meeting"
                break;
              default:
                break;
            }
            data.valueList = JSON.stringify(valueList)
            data.title_en = "Visit Reason"
          })
        }
          break;
        case 'visitAddress':
          data.title_en = "Visit Address"
          break;
        case 'carNumber':
          data.title_en = "Car Number"
          break;
        case 'note':
          data.title_en = "Comments"
          break;
        case 'peer':
          data.title_en = "Accompany Visitor"
          break;
        case 'unit':
          data.title_en = "Visit Company"
          break
        default:
          break;
      }
    },

    onClickType(item) {

      let data = this.crateFormData(item)
      let name = data.name
      let find
      console.log("@@@", "name", name);
      switch (name) {
        case 'reason':
        case 'unit':
        case 'visitAddress':
        case 'carNumber':
        case 'note':
        case 'peer':
          find = this.formDefineList.find(item => item.name === name)
          if (!find) {
            this.addDefaultEngine(data)
            this.formDefineList.push(data)
          } else {
            this.$message.error("常用字段不能重复")
          }
          break;
        default:

          this.formDefineList.push(data)
          break;
      }

    },


    formatTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    swapElements(array, index1, index2) {
      if (index1 < 0 || index1 >= array.length || index2 < 0 || index2 >= array.length) {
        return; // 索引超出数组范围，不进行交换
      }

      // 使用临时变量进行交换
      var temp = array[index1];
      array[index1] = array[index2];
      array[index2] = temp;
    },

    handleMessage(index, event) {
      if (event == 'up') {
        let curIndex = index
        let targetIndex = index - 1

        if (targetIndex < 0 || curIndex >= this.formDefineList.length) {
          return
        }

        let temp = this.formDefineList[curIndex]
        this.formDefineList.splice(curIndex, 1, this.formDefineList[targetIndex]);
        this.formDefineList.splice(targetIndex, 1, temp);

      } else if (event == 'down') {
        let curIndex = index
        let targetIndex = index + 1

        if (curIndex < 0 || targetIndex >= this.formDefineList.length) {
          return
        }

        let temp = this.formDefineList[curIndex]
        this.formDefineList.splice(curIndex, 1, this.formDefineList[targetIndex]);
        this.formDefineList.splice(targetIndex, 1, temp);
      } else if (event == 'del') {
        this.formDefineList.splice(index, 1)
      }
    },

    submitForm() {
      let postData = JSON.parse(JSON.stringify(this.formDataOrigin))
      postData.formItems = JSON.parse(JSON.stringify(this.formDefineList))
      console.log("@@@ addFormData param111", postData);
      addFormData(postData).then(({data}) => {
        console.log("@@@ addFormData result", data);
        if (data.code == 200) {
          this.formDataOrigin = data.data
          this.setFormDefineList(data.data.formItems)
          this.$message.success(data.msg);
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch((err) => {
        console.log("getFormData err", err)
        this.showNetErrMsg();
      })
    },
    resetForm() {
      this.setFormDefineList(this.formDataOrigin.formItems)

    },

    setFormDefineList(originList) {
      let defineList = []
      defineList.push(...JSON.parse(JSON.stringify(originList)))
      if (defineList.length === 0) {
        defineList.push(...[
          {
            id: 2,
            name: "startTime",
            title: "开始时间",
            title_en: "Begin Time",
            type: "beginTime",
            value: "",
            valueList: "",
            valueDefault: "",
            required: 1
          },
          {
            id: 3,
            name: "endTime",
            title: "结束时间",
            title_en: "End Time",
            type: "endTime",
            value: "",
            valueList: "",
            valueDefault: "",
            required: 1
          }
        ])
      }
      this.formDefineList = defineList

      this.formDefineList.forEach(item => {
        if (item.id > this.maxId) {
          this.maxId = item.id
        }
      })
    }

  }, // end methods

  computed: {
    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
          return true
        case "VIEW":
        case "GUARD":
        case "STAFF":
          return false
        default:
          return this.$store.state.myPermissions.includes("VISITOR_FORM_MODIFY")
      }
    }
  },

  mounted() {

    if (this.visitType === "subscribe") {
      this.apiType = "BOOK_APPLY"
    } else if (this.visitType === "invite") {
      this.apiType = "INVITE_APPLY"
    }
    console.log("apiType", this.apiType)
    getFormData(this.apiType).then(({data}) => {
      console.log("getFormData", data)
      if (data.code === 200 && data.data && data.data.formItems && data.data.formItems.length > 0) {
        this.formDataOrigin = data.data

        this.setFormDefineList(data.data.formItems)

      } else {
        this.createDefaultForm()
      }
    }).catch((err) => {
      console.log("getFormData err", err)
      this.createDefaultForm()
    })

  }
}

</script>

<style lang="less" scoped>

h3 {
  margin: 20px 0;
}

h4 {
  margin: 15px 0;
}

.form-setting {
  display: flex;
  justify-content: flex-start;

  .right-content {
    margin-left: 15px;
  }

  .type-box {
    display: block;
  }

  .two-column-list {
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 14px;
  }

  .two-column-list li {
    width: 50%;
    /* 每列占据宽度的一半 */
    float: left;
    /* 左浮动，使得两列并排显示 */
    box-sizing: border-box;
    /* 让边框和内边距计算在宽度内 */
    padding-bottom: 10px;
  }

  .two-column-list li:hover {
    color: #F56C6C;
  }

  .clearfix::after {
    content: "";
    display: table;
    clear: both;
  }

  .icon-color {
    color: #409EFF;
  }

  .input-width {
    width: 200px;
  }

}
</style>
